<template>
  <component
    :is="as"
    class="ui-card"
    :class="[
      `ui-card--${variant}`,
      `ui-card--${padding}`,
      {
        'ui-card--hover': hover,
        'ui-card--clickable': clickable,
      },
    ]"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: "HsCard",
  props: {
    as: {
      type: String,
      default: "div",
    },
    variant: {
      type: String,
      default: "default",
      validator: (value) => ["default", "soft", "strong", "flat"].includes(value),
    },
    padding: {
      type: String,
      default: "md",
      validator: (value) => ["none", "sm", "md", "lg"].includes(value),
    },
    hover: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.ui-card {
  border: 1px solid var(--hs-border, rgba(148, 163, 184, 0.22));
  border-radius: 24px;
  min-width: 0;
  position: relative;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.ui-card--default {
  background:
    radial-gradient(circle at 92% 0%, color-mix(in srgb, var(--hs-primary, #3293ec) 9%, transparent), transparent 34%),
    color-mix(in srgb, var(--hs-surface, #ffffff) 94%, transparent);
  box-shadow: var(--hs-shadow-card, 0 18px 45px -30px rgba(15, 23, 42, 0.45));
}

.ui-card--soft {
  background: color-mix(in srgb, var(--hs-bg-soft, #f1f5f9) 58%, var(--hs-surface, #ffffff));
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.04);
}

.ui-card--strong {
  background: linear-gradient(135deg, #111827, #172033);
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: 0 22px 55px rgba(15, 23, 42, 0.2);
  color: #fff;
}

.ui-card--flat {
  background: var(--hs-surface, #ffffff);
  box-shadow: none;
}

.ui-card--none {
  padding: 0;
}

.ui-card--sm {
  padding: 0.85rem;
}

.ui-card--md {
  padding: 1.1rem;
}

.ui-card--lg {
  padding: 1.35rem;
}

.ui-card--hover:hover,
.ui-card--clickable:hover {
  border-color: color-mix(in srgb, var(--hs-primary, #3293ec) 34%, var(--hs-border, rgba(148, 163, 184, 0.22)));
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.1);
  transform: translateY(-2px);
}

.ui-card--clickable {
  cursor: pointer;
}
</style>
